import { icon_back_large } from 'components/base/images';
import MuiButton from 'components/common/button/MuiButton';
import CustomText from 'components/common/text/CustomText';
import { getMapperTeethNumbering, withZeroNum } from 'lib/library';
import { IToothShade, Tooth } from 'lib/types/projectTypes';
import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import IndicationList from './IndicationList';
import MaterialList from './MaterialList';
import OptionList from './OptionList';

interface IndicationModalProps {
  defaultOption: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  advancedOption: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  defaultValue: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  advancedValue: {
    inputs: {};
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  isBeElement: {
    checkBox: boolean;
    radioButton: boolean;
    slider: boolean;
  };
  materialShadeList: IToothShade[];
  teeth: {
    value: object[] | any;
    onChange: (e: any) => void;
    setValue: (value: object[] | any) => void;
  };
  tooth: {
    value: Tooth;
    onChange: (e: any) => void;
    setValue: (value: Tooth) => void;
  };
  numbering: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  restorationPontic: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  occlusalSurface: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  ceramicMetal: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  indicationFormat: any;
  indicationInfo: any;
  indicationOption: any;
  indicationSeqList: any;
  matchingIndicationPartList: any;
  matchingMaterialList: any;
  matchingImplantList: any;
  matchingAbutmentList: any;
  matchingScanbodyList: any;
  matchMaterailListDef: any;
  matchMaterailListCM: any;
  indicationSeq: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  indication: {
    value: {
      // id: number;
      id: string;
      seq: string;
      color: string;
    };
    onChange: (e: any) => void;
    setValue: (value: object) => void;
  };
  material: { value: string; onChange: (e: any) => void; setValue: (value: string) => void };
  implant: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  abutment: {
    value: number | null;
    onChange: (e: any) => void;
    setValue: (value: number | null) => void;
  };
  scanbody: {
    value: number | null;
    onChange: (e: any) => void;
    setValue: (value: number | null) => void;
  };
  checkSituScan: {
    value: boolean | number;
    onChange: (e: any) => void;
    setValue: (value: boolean | number) => void;
  };
  checkGingivaScan: {
    value: boolean | number;
    onChange: (e: any) => void;
    setValue: (value: boolean | number) => void;
  };
  gapWidthCement: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  minimalTickness: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  millingToolDiameter: {
    value: number | number[] | string | any; // input value 입력시 string
    onChange: (e: any) => void;
    setValue: (value: number | number[] | string | any) => void;
  };
  virtualGingiva: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  thimbleCrown: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  waxupScan: {
    value?: number | null;
    onChange: (e: any) => void;
    setValue: (value?: number | null) => void;
  };
  cervicalAdaption: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  materialShade: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  optionTab: number;
  isMultidie: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  onCloseModal: () => void;
  onChooseIndicationPart: (data: {}) => void;
  onChooseMaterial: (seq: string, alias: string) => void;
  onChooseImplant: (seq: number) => void;
  onChooseAbutment: (seq: number) => void;
  onChooseScanbody: (seq: number) => void;
  onClickTab: (event: ChangeEvent<{}>, newValue: number) => void;
  onApply: () => void;
  onReset: () => void;
}

function IndicationModal({
  defaultOption,
  advancedOption,
  defaultValue,
  advancedValue,
  isBeElement,
  teeth,
  tooth,
  numbering,
  materialShadeList,
  indicationFormat,
  indicationInfo,
  indicationOption,
  indicationSeqList,
  matchingIndicationPartList,
  matchingMaterialList,
  matchingImplantList,
  matchingAbutmentList,
  matchingScanbodyList,
  material,
  implant,
  abutment,
  scanbody,
  checkSituScan,
  checkGingivaScan,
  gapWidthCement,
  minimalTickness,
  millingToolDiameter,
  virtualGingiva,
  thimbleCrown,
  waxupScan,
  cervicalAdaption,
  materialShade,
  restorationPontic,
  occlusalSurface,
  ceramicMetal,
  matchMaterailListDef,
  matchMaterailListCM,
  indicationSeq,
  indication,
  optionTab,
  isMultidie,
  onCloseModal,
  onChooseIndicationPart,
  onChooseMaterial,
  onClickTab,
  onChooseImplant,
  onChooseAbutment,
  onChooseScanbody,
  onApply,
  onReset,
}: IndicationModalProps) {
  return (
    <StyledIndicationModal>
      <div className="indicationModal__main_container">
        <div className="indicationModal__indication_box">
          <div className="indicationModal__title_box">
            <button onClick={onCloseModal}>
              <img src={icon_back_large} />
            </button>
            <CustomText fontSize={36} fontWeight={400}>{`Tooth ${
              !isMultidie.value
                ? withZeroNum(getMapperTeethNumbering(tooth.value?.number, numbering.value))
                : tooth.value?.number % 100
            }`}</CustomText>
          </div>
          <IndicationList
            indicationFormat={indicationFormat}
            indicationInfo={indicationInfo}
            indicationSeqList={indicationSeqList}
            indication={indication}
            onChooseIndicationPart={onChooseIndicationPart}
          />
        </div>
        <div className="indicationModal__material_box">
          <MaterialList
            matchMaterailListDef={matchMaterailListDef}
            // matchMaterailListCM={matchMaterailListCM}
            matchingMaterialList={matchingMaterialList}
            indication={indication}
            material={material}
            isMultidie={isMultidie}
            onChooseMaterial={onChooseMaterial}
          />
        </div>
        <div className="indicationModal__option_box">
          <OptionList
            defaultOption={defaultOption}
            advancedOption={advancedOption}
            defaultValue={defaultValue}
            advancedValue={advancedValue}
            isBeElement={isBeElement}
            matchingImplantList={matchingImplantList}
            matchingAbutmentList={matchingAbutmentList}
            matchingScanbodyList={matchingScanbodyList}
            materialShadeList={materialShadeList}
            indicationSeq={indicationSeq}
            indication={indication}
            indicationOption={indicationOption}
            material={material}
            implant={implant}
            abutment={abutment}
            scanbody={scanbody}
            checkSituScan={checkSituScan}
            checkGingivaScan={checkGingivaScan}
            gapWidthCement={gapWidthCement}
            minimalTickness={minimalTickness}
            millingToolDiameter={millingToolDiameter}
            virtualGingiva={virtualGingiva}
            thimbleCrown={thimbleCrown}
            waxupScan={waxupScan}
            cervicalAdaption={cervicalAdaption}
            materialShade={materialShade}
            restorationPontic={restorationPontic}
            occlusalSurface={occlusalSurface}
            ceramicMetal={ceramicMetal}
            optionTab={optionTab}
            onChooseImplant={onChooseImplant}
            onChooseAbutment={onChooseAbutment}
            onChooseScanbody={onChooseScanbody}
            onClickTab={onClickTab}
          />
        </div>
      </div>
      <div className="indicationModal__button_container">
        <div className="indicationModal__button_box">
          <MuiButton
            disableElevation
            variant="outlined"
            className="indicationModal__button_item"
            onClick={onReset}
          >
            Reset
          </MuiButton>
          <MuiButton
            disableElevation
            variant="contained"
            className="indicationModal__button_item"
            onClick={onApply}
            disabled={Object.keys(indication.value).length < 1}
          >
            Ok
          </MuiButton>
        </div>
      </div>
    </StyledIndicationModal>
  );
}

const StyledIndicationModal = styled.div<{}>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${color.white};
  .indicationModal__main_container {
    /* padding: 30px 0 0 40px; */
    display: flex;
    flex-grow: 1;
    height: calc(100% - 109px);
    .indicationModal__indication_box {
      display: flex;
      flex-direction: column;
      padding: 30px 0 0 40px;
      width: 880px;
      height: 100%;
      border-right: 1px solid #e1e1e7;
      .indicationModal__title_box {
        display: flex;
        align-items: center;
        column-gap: 10px;
      }
    }
    .indicationModal__material_box {
      display: flex;
      flex-direction: column;
      padding: 67px 0 0 40px;
      width: 330px;
      height: 100%;
      border-right: 1px solid #e1e1e7;
    }
    .indicationModal__option_box {
      display: flex;
      flex-direction: column;
      padding: 67px 40px 0 40px;
      width: 710px;
      height: 100%;
    }
  }
  .indicationModal__button_container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 40px;
    height: 108px;
    border-top: 1px solid #e1e1e7;
    .indicationModal__button_box {
      display: flex;
      column-gap: 12px;
      .indicationModal__button_item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 190px;
        height: 50px;
        padding: 10px;
        border-radius: 3px;
      }
    }
  }
`;

export default IndicationModal;
